export const appLoaded = (state: any) => state.objects.loaded;
